import { render, staticRenderFns } from "./en.vue?vue&type=template&id=abe458f6&scoped=true&lang=html&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe458f6",
  null
  
)

export default component.exports